import { graphql } from '@/gql/graphql';

export default graphql(/* GraphQL */ `
  fragment InsertMessageReactionOneOptimistic on message {
    id
    __typename
    reaction_count
    your_reactions {
      id
      content
    }
  }
`);
